import { capitalize } from "lodash";
import { Link, LinkProps } from "react-router-dom";
import type { OrderItem } from "@/entities/order-item";
import { OrderItemProductionStatus } from "@/entities/order-item-production-status";

type OrderItemProductionStatusPillProps = {
  item: OrderItem;
  linkProps?: Omit<LinkProps, "to">;
};

export function OrderItemProductionStatusPill({
  item,
  linkProps,
}: OrderItemProductionStatusPillProps) {
  const colors = {
    [OrderItemProductionStatus.New]:
      "bg-yellow-100 text-yellow-700 hover:bg-yellow-200 hover:text-yellow-800",
    [OrderItemProductionStatus.Active]:
      "bg-cyan-100 text-cyan-600 hover:bg-cyan-200 hover:text-cyan-700",
    [OrderItemProductionStatus.Setup]: "bg-cyan-100 text-cyan-600 hover:bg-cyan-200 hover:text-cyan-700",
    [OrderItemProductionStatus.Available]:
      "bg-zinc-200 text-zinc-600 hover:bg-zinc-300 hover:text-zinc-700",
    [OrderItemProductionStatus.Migrated]:
      "bg-green-100 text-green-600 hover:bg-green-300 hover:text-green-700",
    [OrderItemProductionStatus.Completed]:
      "bg-green-100 text-green-600 hover:bg-green-300 hover:text-green-700",
    [OrderItemProductionStatus.Cancelled]:
      "bg-zinc-100 text-zinc-600 hover:bg-zinc-300 hover:text-zinc-700",
    [OrderItemProductionStatus.Expired]:
      "bg-red-100 text-red-600 hover:bg-red-200 hover:text-red-700",
    other: "bg-cyan-100 text-cyan-600 hover:bg-cyan-200 hover:text-cyan-700",
  }[item.productionStatus ?? "other"];

  return (
    <Link
      to={`/order-items/${item.id}/campaign-request`}
      {...linkProps}
      className={[
        "inline-block rounded-full text-xs py-0.5 px-2 whitespace-nowrap font-bold",
        colors,
      ].join(" ")}
    >
      {capitalize(item.productionStatus ?? "")}
    </Link>
  );
}
